
import React, { useEffect } from "react";

const RedirectPartnerList = () => {
  const queryParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    const url = new URL(process.env.REACT_APP_REDIRECT_URL);
    url.searchParams.set("s", queryParams.get("s")); 
    window.location.href = url.toString(); 
  }, []);

  return null;
};

export default RedirectPartnerList;